<div class="db-tab-subheads">
  <div [ngClass]="{'db-tab-subhead_active': !subTabId || subTabId === activeSubTabId}" >
    <a class="db-tab-subhead" (click)="onClick()">
      <ng-content></ng-content>
    </a>
  </div>
</div>
